import { Box, Button, HStack, Text } from "@chakra-ui/react";
import React from "react";

export default function IconText({ icon, text, props }) {
  return (
    <Box>
      <HStack as={Button} variant="unstyled" height="auto" {...props}>
        {icon}

        <Text>{text}</Text>
      </HStack>
    </Box>
  );
}
